














import { Component, Vue, Prop } from "vue-property-decorator";
import { Profit } from "@foxone/api/src/models/hfox";

@Component
class PriceChart extends Vue {
  @Prop() profits!: Profit[];

  priceyAxis = {
    splitLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    scale: true
  };

  priceOptions = {
    series: {
      showSymbol: false
    },
    yAxis: {
      splitNumber: 3,
      axisLabel: {
        fontSize: 12,
        color: "#999999",
        inside: true
      }
    },
    xAxis: {
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 12,
        color: "#999999"
      }
    }
  };

  get priceProfits() {
    const chartData = {
      columns: [] as string[],
      rows: [] as any[]
    };
    if (this.profits.length !== 0) {
      this.profits.forEach(e => {
        const chartValue = {} as any;
        chartValue.date = this.$common.utils.date.formatDate(e.date, "MM/DD");
        chartValue.price = Number.parseFloat(e.price);
        chartValue.avgPrice = Number.parseFloat(e.avg_price);
        chartData.rows.push(chartValue);
      });
      chartData.columns = ["date", "price", "avgPrice"];
    }
    return chartData;
  }

  get priceChartSettings() {
    return {
      labelMap: {
        price: this.$t("common.price.current"),
        avgPrice: this.$t("common.price.avg")
      },
      metrics: ["price", "avgPrice"],
      dimension: ["date"]
    };
  }
}
export default PriceChart;
